import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NavigationService } from '../services/navigation.service';
import { inject } from '@angular/core';

export const isTeacherOrHigherGuard: CanActivateFn = async (route, state) => {
	const authService = inject(AuthService);
	const nav = inject(NavigationService);

	const isAdmin: boolean = await authService.isAdmin$();
	const isClientAdmin: boolean = await authService.isClientAdmin$();
	const isTeacher: boolean = await authService.isTeacher$();
	const isDemo: boolean = await authService.isDemo$();
	const isSchoolAdmin: boolean = await authService.isSchoolAdmin$();
	const isDistrictAdmin: boolean = await authService.isDistrictAdmin$();

	if (isAdmin || isClientAdmin || isTeacher || isDemo || isSchoolAdmin || isDistrictAdmin) {
		return true;
	} else {
		nav.navigate(['/']);
		return false;
	}
};
